/* eslint-disable @typescript-eslint/no-unused-vars */
import { useContext, useEffect, useState } from "react";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import "./styles.css";
// import reportSources from "./reportSources.json";
import {
  clearLocalStorageData,
  getLocalStorageData,
  setLocalStorageData,
} from "../../../../shared/utils/localStorage";
import useMutation from "../../../../shared/components/hooks/useMutation";
import useQuery from "../../../../shared/components/hooks/useQuery";
import React from "react";
import Paper from "@mui/material/Paper";
import { useLocalStorage } from "../../../../contexts/LocalStorageContext";
import { ZSAutocomplete } from "../../../../shared/components/autoComplete";
import { LocalStorageContext } from "../../../../contexts/LocalStorageContext";
import useLazyQuery from "../../../../shared/components/hooks/useLazyQuery";
import { usePropertyReportContext } from "../../../../contexts/PropertyReportContext";
import EditIcon from "@mui/icons-material/Edit";
import { useFormik } from "formik";
import PropertyEditDialog from "./components/propertyEditModal";
import reportSources from "../../../../shared/json/reportSources.json";
import BenchmarkUnlockDialog from "../../../../shared/components/benchmarkUnlockDialog";

const AnimatedUserBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "open",
})<{ open: boolean }>(({ theme, open }) => ({
  display: "flex",
  alignItems: "center",
  // background: theme.palette.background.paper,
  background: "transparent",
  // borderRadius: 20,
  boxShadow: theme.shadows[2],
  overflow: "hidden",
  height: "50px",
  width: open ? "auto" : 60,
  transition: "width 0.3s ease",
  cursor: "pointer",
  position: "relative",
  justifyContent: "flex-end",
  paddingRight: theme.spacing(1),
}));

const AvatarInitial = styled("div", {
  shouldForwardProp: (prop) => prop !== "open",
})<{ open: boolean }>(({ theme, open }) => ({
  backgroundColor: open ? " rgba(73, 89, 65, 1)" : "rgba(128, 142, 125, 1)", // Change color based on open state
  color: theme.palette.common.white,
  width: "36px",
  height: "36px",
  borderRadius: "50%",
  fontWeight: "500",
  fontSize: "18px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginLeft: theme.spacing(1),
  flexShrink: 0,
  boxSizing: "border-box",
  transition: "background-color 0.3s ease", // Smooth color transition
  position: "relative",
  zIndex: 100,
}));

const LogoutButtonContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "visible",
})<{ visible: boolean }>(({ theme, visible }) => ({
  opacity: visible ? 1 : 0,
  transform: visible ? "translateX(0)" : "translateX(-10px)",
  transition: "opacity 0.3s ease, transform 0.3s ease",
  whiteSpace: "nowrap",
  backgroundColor: "rgba(73, 89, 65, 1)",
  marginRight: "-45px",
  height: "36px",
  display: "flex",
  position: "relative",
  zIndex: 1,
  borderTopLeftRadius: "50px",
  borderBottomLeftRadius: "50px",
  borderTopRightRadius: "50px",
  borderBottomRightRadius: "50px",
  borderRight: "0.45px solid rgba(255, 255, 255, 0.40)",
  color: "#fff",
}));

function HeaderUserbox() {
  const { pId, reportId: urlReportId } = useParams();
  const [openBenchmarkUnlockDialog, setOpenBenchmarkUnlockDialog] =
    React.useState(false);
  const navigate = useNavigate();
  const localStorageData = getLocalStorageData("userData");
  // const propertyIdFromLocalStorage = getLocalStorageData("propertyId");
  const [isOpen, setOpen] = useState<boolean>(false);
  const { loading: apiLoading, modifyData } = useMutation();
  const location = useLocation();
  const { propertyId, updatePropertyId, propertyTitle, updateTitle } =
    useLocalStorage();
  const [openDialog, setOpenDialog] = React.useState(false);
  const { userData, updateUserData } = useContext(LocalStorageContext);
  const id = localStorageData?.userId;
  // const id = userData?.userId;

  const { propertyReportId, setPropertyReports, setLoading } =
    usePropertyReportContext();

  const [searchParams, setSearchParams] = useSearchParams();
  const token = getLocalStorageData("token");
  const [isMeatadesk, setIsMeatadesk] = useState<boolean>(false);
  const { updateReports } = useLocalStorage();

  useEffect(() => {
    fetchAssignedApplications();
  }, []);

  const fetchAssignedApplications = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_LOGIN_GCOM_UNIFIED_API_URL}/application/myApplication`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );

    if (response) {
      const responseData = await response.json();

      const applicationAccessKeys =
        responseData?.data?.map(
          (item: any) => item?.application?.name || item?.name,
        ) || [];

      const uniqueAccessKeys = [
        ...new Set(
          applicationAccessKeys.map((name: string) =>
            name?.toUpperCase().trim(),
          ),
        ),
      ];
      const isMeatadeskAccess = uniqueAccessKeys.includes("METADESK")
        ? true
        : false;
      setIsMeatadesk(isMeatadeskAccess);
    }
  };

  useEffect(() => {
    const tokenFromParams = searchParams.get("token");
    if (tokenFromParams) {
      const decodedToken = decodeURIComponent(tokenFromParams);
      if (decodedToken !== getLocalStorageData("token")) {
        setLocalStorageData("token", decodedToken);
        if (pId) {
          setLocalStorageData("propertyId", pId);
          updatePropertyId(pId);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  const handleLogout = async () => {
    const token = getLocalStorageData("token");
    const response = await fetch(
      `${process.env.REACT_APP_LOGIN_GCOM_UNIFIED_API_URL}/auth/logout`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );
    clearLocalStorageData();
    const redirectUrl = `${process.env.REACT_APP_GLOBAL_AUTH_CLIENT_FRONTEND}/login`;
    window.location.href = redirectUrl;
  };

  // const name = localStorageData?.firstName;
  const name = localStorageData?.firstName;
  const email = localStorageData?.email;

  const avatarName = email?.charAt(0)?.toUpperCase();

  if (pId && !propertyId) {
    updatePropertyId(pId);
  }
  // else if (!pId && !propertyId) {
  //   updatePropertyId(propertyIdFromLocalStorage);
  // }

  const {
    data: propertyReportData,
    loading: propertyReportLoading,
    fetchData: fetchReport,
  } = useLazyQuery(`customer/property-report/by-property/${propertyId}`);

  const {
    data: assignedData = [],
    loading,
    error,
    fetchData,
  } = useQuery(`customer/properties/user/${id}/assigned`);

  const {
    data: propertyData,
    loading: propertyLoading,
    fetchData: fetchProperty,
  } = useLazyQuery(`customer/properties/${propertyId}`);

  useEffect(() => {
    if (propertyReportLoading) {
      setLoading(propertyReportLoading);
    }
  }, [propertyReportLoading]);

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  const linkReports =
    (propertyReportData as any)?.linkReports?.map((x: any) => ({
      ...x,
      id: `link-${x?.id}`,
      isBenchmark: false,
      isDocReport: false,
    })) ?? [];

  const benchmarkReports =
    (propertyReportData as any)?.benchmarkReports?.map((x: any) => {
      const matchingSource = reportSources.benchmarkReports.sources.find(
        (source: any) => source.name === x?.reportSource?.source,
      );

      return {
        ...x,
        isBenchmark: true,
        isDocReport: false,
        routePath: `benchmarking-report/${propertyId}/${matchingSource?.key ?? ""}`,
      };
    }) ?? [];

  const apiDocReports =
    (propertyReportData as any)?.docReports?.map((x: any) => ({
      ...x,
      id: `doc`,
      isDocReport: true,
      isBenchmark: false,
      reportSource: {
        ...(x.reportSource ?? {}),
        source: "Performance Summary",
      },
    })) ?? [];

  // const { sources: extraSources, heading: extraHeading } = reportSources.docReports;
  // const extraDocReports = extraSources.map((source) => ({
  //   id: `${source.key}`,
  //   isDocReport: true,
  //   heading: extraHeading,
  //   propertyId,
  //   reportSource: {
  //     source: source.name,
  //     displayOrder: source.displayOrder,
  //   },
  //   routePath: `benchmarking-report/${propertyId}/${source.key}`,
  // }));

  const sortedLinkReports = [...linkReports].sort(
    (a, b) =>
      (a?.reportSource?.displayOrder ?? Infinity) -
      (b?.reportSource?.displayOrder ?? Infinity),
  );
  const isOnBenchmarkingPage = location.pathname.includes(
    "/benchmarking-report",
  );
  useEffect(() => {
    updateReports({
      linkReportsCount: linkReports.length,
      apiDocReportsCount: apiDocReports.length,
      benchmarkReportsCount: benchmarkReports.length,
    });
  }, [linkReports.length, apiDocReports.length, benchmarkReports.length]);
  const allReports = [
    ...sortedLinkReports,
    ...apiDocReports,
    ...benchmarkReports,
  ];

  useEffect(() => {
    if (!(assignedData as any)) return;

    if (
      (assignedData as any).length &&
      (propertyId == null || propertyId === "null")
    ) {
      const propertyWithReport = (assignedData as any).find((prop: any) =>
        allReports?.some((report: any) => report?.propertyId === prop?.id),
      );

      const selectedProperty = propertyWithReport || (assignedData as any)[0];

      if (selectedProperty?.id) {
        updatePropertyId(selectedProperty.id);
        setLocalStorageData("propertyId", selectedProperty.id);
        navigate(`/dashboard/${selectedProperty.id}`);
      }
    }
  }, [assignedData, allReports, propertyId]);

  // useEffect(() => {
  //   if (!loading) {
  //     if (assignedData && (assignedData as any)?.length > 0) {
  //       const urls = (assignedData as any)?.map((item: any) => {
  //         if (item.id === propertyId) {
  //         }
  //         return {
  //           value: item?.id,
  //           label: item?.title,
  //           dsHotelId: item?.dsHotelId,
  //         };
  //       });
  //     }
  //   }
  // }, [assignedData]);

  let selectValue: any;
  const properties = (assignedData as any)?.map((property: any) => {
    if (String(propertyId) === String(property.id)) {
      selectValue = {
        value: property.id,
        label: property.title,
        dsHotelId: property.dsHotelId,
      };
    }
    return {
      value: property.id,
      label: property.title,
      dsHotelId: property.dsHotelId,
    };
  });

  useEffect(() => {
    if (selectValue && selectValue.label !== propertyTitle) {
      updateTitle(selectValue.label);
    }
  }, [selectValue, propertyTitle, updateTitle]);

  const handlePropertyChange = (selectedOption: any) => {
    // setLocalStorageData("propertyId", selectedOption.value);
    console.log("selectedOption >>> ", selectedOption);
    // fetchReport();
    setLoading(true);
    updateTitle(selectedOption.label);
    updatePropertyId(selectedOption.value);
    updateUserData({
      ...(userData || {}),
    });
  };

  const isValidPropertyId =
    propertyId &&
    propertyId !== "" &&
    propertyId !== null &&
    propertyId !== "null";

  useEffect(() => {
    if (!isValidPropertyId) return;

    console.log("PROPERTY CHANGED:", propertyId);

    setLoading(true);

    fetchReport();
  }, [propertyId]);

  useEffect(() => {
    if (!isValidPropertyId) return;

    if (propertyReportLoading) {
      setLoading(true);
      return;
    }

    if (!propertyReportData) {
      setLoading(false);
      return;
    }

    const isOnDashboard = location.pathname.includes("dashboard");

    // No reports available
    if ((!allReports || allReports.length === 0) && !propertyReportLoading) {
      setLoading(false);
      setPropertyReports(propertyId, null, [], false);
      setOpenBenchmarkUnlockDialog(true);
      return;
    }

    const effectiveReportId = isOnBenchmarkingPage
      ? null
      : urlReportId || propertyReportId;
    const currentPath = location.pathname;

    const findMatchingReport = () => {
      // Normal property report
      if (!isOnBenchmarkingPage) {
        return allReports.find(
          (r: any) => String(r.id) === String(effectiveReportId),
        );
      }

      // Benchmark report
      const pathParts = currentPath.split("/");
      const currentKey = pathParts[pathParts.length - 1];

      return benchmarkReports.find((r: any) =>
        r.routePath?.endsWith(`/${currentKey}`),
      );
    };

    const matchingReport = findMatchingReport();
    const firstReport = allReports[0];
    if (isOnBenchmarkingPage && !matchingReport && allReports?.length === 0) {
      setLoading(false);
      setOpenBenchmarkUnlockDialog(true);
      return;
    }

    setLoading(false);

    setPropertyReports(
      propertyId,
      matchingReport ? matchingReport.id : firstReport.id,
      allReports,
      matchingReport ? matchingReport.isDocReport : firstReport.isDocReport,
    );

    if (isOnDashboard) {
      navigate(`/dashboard/${propertyId}`);
    } else {
      let targetPath = "";

      if (matchingReport) {
        if (matchingReport.routePath) {
          console.log("sdsdsdsas");
          targetPath = `/${matchingReport.routePath}`;
        } else {
          console.log("sds");
          targetPath = `/property-report/${propertyId}/${matchingReport.id}`;
        }
      } else {
        console.log("ddd");
        targetPath = firstReport.routePath
          ? `/${firstReport.routePath}`
          : `/property-report/${propertyId}/${firstReport.id}`;
      }

      if (currentPath !== targetPath) {
        navigate(targetPath);
      }
    }
  }, [
    propertyReportData,
    propertyId,
    propertyReportLoading,
    location.pathname,
    urlReportId,
    propertyReportId,
  ]);

  const propertySettingsFields = [
    {
      id: "property-title",
      name: "title",
      label: "Title",
      type: "text",
      placeholder: "Enter title",
      required: true,
    },
    {
      id: "Property-streetAddress",
      name: "addressLane1",
      label: "Street Address",
      type: "text",
      placeholder: "Enter Street Address",
      required: false,
    },
    {
      id: "Property-streetAddress-2",
      name: "addressLane2",
      label: "Street Address 2",
      type: "text",
      placeholder: "Enter Street Address 2",
      required: false,
    },
    {
      id: "Property-postalCode",
      name: "postalCode",
      label: "Postal Code",
      type: "text",
      placeholder: "Enter Postal Code",
      required: false,
    },
    {
      id: "Property-city",
      name: "city",
      label: "City",
      type: "text",
      placeholder: "Enter City",
      required: false,
    },
    {
      id: "Property-state",
      name: "state",
      label: "State",
      type: "text",
      placeholder: "Enter State",
      required: false,
    },
    {
      id: "Property-country",
      name: "country",
      label: "Country",
      type: "text",
      placeholder: "Enter Country",
      required: false,
    },
  ];

  const property = Array.isArray(propertyData)
    ? (propertyData as any)?.find((prop: any) => prop?.id == propertyId)
    : propertyData; // if it’s already an object, just take it

  const propertyForm = useFormik({
    initialValues: {
      title: property?.title ?? "",
      propertySetting: {
        title: property?.title ?? "",
        addressLane1: property?.propertySetting?.addressLane1 ?? "",
        addressLane2: property?.propertySetting?.addressLane2 ?? "",
        postalCode: property?.propertySetting?.postalCode ?? null,
        city: property?.propertySetting?.city ?? "",
        state: property?.propertySetting?.state ?? "",
        country: property?.propertySetting?.country ?? "",
      },
    },
    enableReinitialize: true,
    onSubmit: async (formData: any) => {
      const result = await modifyData(
        `/customer/properties/${propertyId}`,
        "put",
        {
          ...formData,
          title: formData.propertySetting.title,
          propertySetting: {
            ...formData.propertySetting,
            name: formData.propertySetting.title,
          },
        },
        propertyForm,
      );
      if (result) {
        propertyForm.resetForm({ values: formData });
        fetchData();
        setOpenDialog(false);
      }
    },
  });

  const handleOpenDialog = () => {
    if (isValidPropertyId) {
      fetchProperty();
      setOpenDialog(true);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleMetadeskLoginRedirect = () => {
    const metadeskClientUrl = process.env.REACT_APP_METADESK_CLIENT_FRONTEND;
    if (isMeatadesk) {
      const redirectUrl = `${metadeskClientUrl}?token=${encodeURIComponent(
        token,
      )}`;

      window.location.href = redirectUrl;
    } else {
      window.open(`${metadeskClientUrl}`, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        sx={{ justifyContent: "flex-end", alignItems: "center" }}
      >
        <Grid
          className="PropertySelect"
          item
          xs={12}
          md={10}
          sx={{
            "@media (max-width:769px)": {
              marginBottom: "24px",
            },
          }}
        >
          <Stack
            direction="row"
            spacing={1}
            sx={{
              marginTop: 0.5,
              "@media (max-width:769px)": {
                position: "relative",
                left: "20%",
              },
            }}
          >
            {/* {selectValue ? ( */}
            <>
              <Item className="propertySelectItem">
                <p className="form-label">Select Property</p>
              </Item>
              <Item className="searchBarItem">
                <Box
                  sx={{
                    width: "310px",
                    paddingTop: "0px",
                    color: "#1E1E1E",
                    "@media (max-width:769px)": {
                      width: "200px",
                    },
                  }}
                >
                  <ZSAutocomplete
                    options={properties}
                    disableClearable={true}
                    placeholder="Select Property"
                    setValue={handlePropertyChange}
                    defaultValue={selectValue}
                    textFieldClassName="select-property"
                  />
                </Box>
              </Item>
              <Item className="edit-property-icon" onClick={handleOpenDialog}>
                <EditIcon fontSize="small" />
              </Item>
            </>
            {/* ) : (
              ""
            )} */}
          </Stack>
        </Grid>
        <Grid
          item
          xs={12}
          md={2}
          sx={{
            paddingRight: "0px",
            justifyContent: "flex-end",
            display: "flex",
            "@media (max-width:769px)": {
              position: "absolute",
              top: 0,
            },
          }}
        >
          <AnimatedUserBox open={isOpen} onClick={() => setOpen(!isOpen)}>
            <LogoutButtonContainer visible={isOpen}>
              <Button
                onClick={handleLogout}
                size="small"
                sx={{
                  color: "#fff",
                  textTransform: "none",
                  fontSize: "12px",
                  borderColor: "green",
                  paddingLeft: "0px",
                }}
                // startIcon={<LockOpenTwoToneIcon />}
              >
                Logout
              </Button>
            </LogoutButtonContainer>
            <AvatarInitial open={isOpen}>{avatarName}</AvatarInitial>{" "}
            {/* Pass open prop */}
          </AnimatedUserBox>
        </Grid>

        <Grid
          item
          xs={12}
          justifyContent="flex-end"
          alignItems="center"
          className="metasearch-link-grid"
        >
          <Typography className="metasearch-link-typography">
            <span
              className="metasearch-link-text"
              onClick={handleMetadeskLoginRedirect}
            >
              Looking for your metasearch performance? Log into Metadesk.
            </span>
          </Typography>
        </Grid>
      </Grid>

      <PropertyEditDialog
        open={openDialog}
        onClose={handleCloseDialog}
        propertyForm={propertyForm}
        propertySettingsFields={propertySettingsFields}
        submitDisabled={
          !propertyForm.isValid ||
          !propertyForm.dirty ||
          propertyForm.isSubmitting
        }
        loading={propertyLoading}
        submitLoading={apiLoading}
      />
      {isOnBenchmarkingPage &&
        benchmarkReports.length === 0 &&
        !propertyReportLoading && (
          <BenchmarkUnlockDialog
            open={openBenchmarkUnlockDialog}
            onClose={() => {
              setOpenBenchmarkUnlockDialog(false);
              navigate(`/dashboard/${propertyId}`);
            }}
          />
        )}
    </>
  );
}

export default HeaderUserbox;
